const base = require("../../../tailwind.config.js").theme.screens

const breakpoints = Object.entries(base).reduce((acc, [screen, value]) => {
    acc[screen] = parseInt(value, 10)
    return acc
}, {})

const reversedBreakpoints = Object.entries(base)
    .reverse()
    .reduce((acc, [screen, value]) => {
        acc[screen] = parseInt(value, 10)
        return acc
    }, {})

export default function (Alpine) {
    Alpine.magic("breakpoint", function ($el, Alpine) {
        return (breakpoint, operator = ">=") => {
            // Simple getter
            if (!breakpoint) {
                for (let screen in reversedBreakpoints) {
                    if (window.innerWidth >= reversedBreakpoints[screen]) {
                        return screen
                    }
                }
            }

            // Compare given breakpoint with current width
            switch (operator) {
                case "<":
                    return window.innerWidth < breakpoints[breakpoint]
                case ">":
                    return window.innerWidth > breakpoints[breakpoint]
                default:
                case ">=":
                    return window.innerWidth >= breakpoints[breakpoint]
                case "<=":
                    return window.innerWidth <= breakpoints[breakpoint]
                case "=":
                    for (let screen in reversedBreakpoints) {
                        if (window.innerWidth >= reversedBreakpoints[screen]) {
                            return breakpoint == screen
                        }
                    }
                    return false
            }
        }
    })
}
